import StructureLabel from 'LuxKit/Label/StructureLabel'
import switchFunc from 'lib/function/switchFunc'
import React, { useMemo } from 'react'
import { PROTECTED_FLIGHTS_NAME } from 'constants/insurance'

const cabinToLabelVariant = switchFunc<React.ComponentProps<typeof StructureLabel>['variant'], string>({
  Business: 'dark',
  First: 'exclusive',
}, 'premium')

interface Props {
  fareFamily: App.FlightFareFamily;
}

function FareFamilyClassLabel(props: Props) {
  const { fareFamily } = props

  const label = useMemo(() => {
    const description = fareFamily.fareFamily.description
    if (fareFamily.withEmbeddedInsurance) {
      return PROTECTED_FLIGHTS_NAME
    }
    return description
  }, [fareFamily.fareFamily.description, fareFamily.withEmbeddedInsurance])

  return (<StructureLabel
    variant={cabinToLabelVariant(fareFamily.cabin)}
  >
    {label}
  </StructureLabel>)
}

export default FareFamilyClassLabel
